import { render, staticRenderFns } from "./IconUploadSimple.vue?vue&type=template&id=1fb6044e&"
import script from "./IconUploadSimple.vue?vue&type=script&lang=js&"
export * from "./IconUploadSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb6044e')) {
      api.createRecord('1fb6044e', component.options)
    } else {
      api.reload('1fb6044e', component.options)
    }
    module.hot.accept("./IconUploadSimple.vue?vue&type=template&id=1fb6044e&", function () {
      api.rerender('1fb6044e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconUploadSimple.vue"
export default component.exports